import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Language } from '../App';
interface PasoonVoiceIntroProps {
  language: Language;
}
export function PasoonVoiceIntro({
  language
}: PasoonVoiceIntroProps) {
  const isPashto = language === 'pashto';
  return <section className="pt-10 md:pt-14 pb-4 md:pb-6 px-6 bg-white text-start" data-id="element-227">
      <div className="max-w-5xl mx-auto" data-id="element-228">
        <AnimatePresence mode="wait" data-id="element-229">
          <motion.div key={language} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.4
        }} data-id="element-230">
            {/* Heading */}
            <div className="mb-6" data-id="element-231">
              <h2 className={`text-3xl md:text-5xl font-bold text-pasoon-dark inline-block relative ${isPashto ? 'font-pashto' : 'font-serif'}`} data-id="element-232">
                {isPashto ? 'پاڅون' : 'Pasoon'}
              </h2>
              <div className="w-16 h-1 bg-pasoon-red rounded-full mt-3" data-id="element-233"></div>
              <p className={`text-xl md:text-2xl font-bold text-pasoon-dark mt-4 ${isPashto ? 'font-pashto leading-loose' : 'font-serif'}`} data-id="element-234">
                {isPashto ? 'د پښتو د بقا او ودې غږ' : 'The Voice of Pashto Survival & Growth'}
              </p>
            </div>

            {/* Body */}
            <p className={`text-lg md:text-xl text-gray-600 max-w-3xl ${isPashto ? 'font-pashto leading-loose' : 'leading-relaxed'}`} data-id="element-235">
              {isPashto ? 'پښتو، چې د خیبر پښتونخوا، بلوچستان او افغانستان ترڅنګ د نړۍ په ګڼو سیمو کې ویل کېږي، د میلیونونو خلکو مورنۍ ژبه ده—خو ډېری یې لا هم د لوستلو او لیکلو له اسانتیاوو بې‌برخې دي.' : 'Pashto, spoken across Khyber Pakhtunkhwa, Balochistan, Afghanistan, and many regions around the world, is the mother tongue of millions — yet many still lack access to reading and writing it with ease.'}
            </p>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>;
}